import { IDrawBudgetItem } from '@apply/api/src/api/DrawApi';

export const calculateBalance = (drawNumber: number, drawBudgetItem: IDrawBudgetItem): number | undefined => {
    const { drawItems, acquisitionAmount } = drawBudgetItem;
    if (!drawItems) return undefined;

    const drawItem = drawItems.find((item) => item.drawNumber == drawNumber);
    if (drawItem?.inspection === undefined) return undefined;

    const totalFunded = drawItems.reduce((sum, item) => {
        if (item?.funded === undefined || item?.inspection === undefined) return sum;

        return item.funded + sum;
    }, acquisitionAmount);
    if (totalFunded === 0) return undefined;

    const outOfBalance = totalFunded - (drawItem?.inspection ?? 0);
    if (outOfBalance <= 0) return undefined;

    return outOfBalance;
};

export interface DrawBudgetCategory {
    id: number;
    description: string;
}

export const getDrawBudgetCategories = (drawBudgetItems: IDrawBudgetItem[]): DrawBudgetCategory[] => {
    return (
        drawBudgetItems
            .filter((item) => item.id > 0)
            .map((item) => {
                return { id: item.id, description: item.description } as DrawBudgetCategory;
            }) ?? []
    );
};
